var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.36,
    height: 40,
    viewBox: "0 0 50.36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(-116 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(116 335.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 51.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M47.889,51.307H2.471A2.375,2.375,0,0,0,0,53.567V85.88a2.375,2.375,0,0,0,2.471,2.26H47.889a2.375,2.375,0,0,0,2.471-2.26V53.567A2.375,2.375,0,0,0,47.889,51.307Zm.894,34.573a.859.859,0,0,1-.894.817H2.471a.859.859,0,0,1-.894-.817V53.567a.859.859,0,0,1,.894-.817H47.889a.859.859,0,0,1,.894.817V85.88Z",
    transform: "translate(0 -51.307)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "_2316254_degree_diploma_education_graduate_resume_icon",
    "data-name": "2316254_degree_diploma_education_graduate_resume_icon",
    d: "M23.561,25.787,14.7,21.356a.8.8,0,0,0-.652,0L5.189,25.787a.275.275,0,0,0,0,.523l1.34.669H6.457v7.4a.583.583,0,0,0-.237.244L5.642,35.8a.586.586,0,0,0,.523.846H7.344a.586.586,0,0,0,.525-.847l-.578-1.169a.583.583,0,0,0-.237-.244V27.239l1.458.734V31.6c0,.821.625,1.583,1.754,2.148a9.4,9.4,0,0,0,4.107.852,9.4,9.4,0,0,0,4.107-.852c1.131-.565,1.754-1.329,1.754-2.148V27.977l3.334-1.666a.275.275,0,0,0,0-.523ZM7.344,36.06H6.171l.586-1.17Zm12.3-4.462c0,.592-.509,1.165-1.43,1.625a8.829,8.829,0,0,1-3.844.792,8.829,8.829,0,0,1-3.844-.792C9.616,32.757,9.1,32.176,9.1,31.6V28.26l4.946,2.479a.8.8,0,0,0,.652,0l4.948-2.475Zm-5.207-1.381a.208.208,0,0,1-.066,0,.236.236,0,0,1-.065,0L5.974,26.045l8.334-4.167a.208.208,0,0,1,.066,0,.237.237,0,0,1,.065,0l8.334,4.167Z",
    transform: "translate(137.241 376.408)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(-1425.435 257.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(1547.503 144.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M239.612,102.97c-.036-.338-.265-.577-.516-.539h-5.24a.367.367,0,0,0-.44.222.721.721,0,0,0,0,.634.367.367,0,0,0,.44.222h5.24c.252.038.48-.2.516-.539Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(1556 144.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2",
    "data-name": "Path 138",
    d: "M239.612,102.97c-.036-.338-.265-.577-.516-.539h-5.24a.367.367,0,0,0-.44.222.721.721,0,0,0,0,.634.367.367,0,0,0,.44.222h5.24c.252.038.48-.2.516-.539Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(1547.503 147.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-3",
    "data-name": "Path 138",
    d: "M239.612,102.967c-.036-.336-.265-.573-.516-.535h-5.24a.367.367,0,0,0-.44.22.712.712,0,0,0,0,.63.367.367,0,0,0,.44.22h5.24c.252.037.48-.2.516-.535Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(1556 147.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-4",
    "data-name": "Path 138",
    d: "M239.612,102.967c-.036-.336-.265-.573-.516-.535h-5.24a.367.367,0,0,0-.44.22.712.712,0,0,0,0,.63.367.367,0,0,0,.44.22h5.24c.252.037.48-.2.516-.535Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(1547.503 151.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-5",
    "data-name": "Path 138",
    d: "M239.612,102.969c-.036-.338-.265-.575-.516-.538h-5.24a.367.367,0,0,0-.44.221.718.718,0,0,0,0,.633.367.367,0,0,0,.44.221h5.24c.252.038.48-.2.516-.538Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(1556 151.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-6",
    "data-name": "Path 138",
    d: "M239.612,102.826a.469.469,0,0,0-.516-.4h-5.24a.412.412,0,1,0,0,.8h5.24a.469.469,0,0,0,.516-.4Z",
    transform: "translate(-233.343 -102.414)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(1556 151.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138-7",
    "data-name": "Path 138",
    d: "M239.612,102.969c-.036-.338-.265-.575-.516-.538h-5.24a.367.367,0,0,0-.44.221.718.718,0,0,0,0,.633.367.367,0,0,0,.44.221h5.24c.252.038.48-.2.516-.538Z",
    transform: "translate(-233.343 -102.414)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(2.439 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M98.525,58.617a.825.825,0,0,1-.825-.825V51.325a.825.825,0,1,1,1.65,0v6.459a.822.822,0,0,1-.825.833Z",
    transform: "translate(27.861 329.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M246.325,58.617a.825.825,0,0,1-.825-.825V51.325a.825.825,0,1,1,1.65,0v6.459a.827.827,0,0,1-.825.833Z",
    transform: "translate(-108.325 329.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M394.125,58.617a.825.825,0,0,1-.825-.825V51.325a.825.825,0,0,1,1.65,0v6.459a.827.827,0,0,1-.825.833Z",
    transform: "translate(-244.511 329.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicYear);
export default __webpack_public_path__ + "static/media/academic-year.8e8ec44ec66b3b7db1d1ef4560b2c046.svg";
export { ForwardRef as ReactComponent };